import { SharedFieldsService } from "../service"
import { Target } from "./target"
import { TargetField } from "./targetField"
import { ICroppingYearModel } from "./types"

const selectableAndSelected: (value: Target) => boolean = (t) => t.selectable && t.selected;

export class EditContext {
    public readonly targets: Target[];
    public readonly fields: TargetField[];

    constructor(
        public readonly targetYear: number,
        private readonly fieldSvc: SharedFieldsService,
        private readonly required: boolean,
        setupExistingYear: boolean
    ) {

        const { fields, targets } = Target.createTargets(this.fieldSvc, this.targetYear, setupExistingYear);
        this.fields = fields;
        this.targets = targets;
    }

    canCommit(): boolean {
        return !this.required || this.hasSelectedCrops();
    }

    hasSelectedCrops(): boolean {
        return this.targets.some(selectableAndSelected);
    }

    getSelectedCrops(): Target[] {
        return this.targets.filter(selectableAndSelected);
    }

    getCroppingYearModel(includeDisabledFields: boolean): ICroppingYearModel {

        const selected = this.getSelectedCrops()

        const model: ICroppingYearModel = {
            HoldingId: this.fieldSvc.holdingId,
            YearId: this.targetYear,

            Fields: selected.filter(t => !t.croppingId).map(t => t.fieldId),
            Cropping: selected.map((t) => t.croppingId).filter(Boolean),

            DisabledFields: includeDisabledFields
                ? this.fields.filter((f) => f.disabled).map((f) => f.fieldId)
                : null,
        };

        return model;
    }
}
